export default __webpack_public_path__ + "static/media/terms.4ed7f625.jpg";